import type { UserTokens } from '@maestro/algolia-insights/types'

import { userTokenCookieService } from '@maestro/algolia-insights/user-token-cookie.service'
import { generateUUID } from '@maestro/algolia-insights/utils'

let anonymousToken: string | undefined
/**
 * Get or create anonymous user token
 * If consent is granted, token is taken from cookie (or created if missing)
 * If consent is not granted, a new token is generated and stored in memory (not persisted)
 * @param hasConsent - Whether user has granted consent for tracking
 */
export function getAnonymousUserToken(hasConsent: boolean): string {
  if (hasConsent) {
    return userTokenCookieService.getOrCreate()
  }
  anonymousToken ??= generateUUID()
  return anonymousToken
}

/**
 * Get user tokens for Algolia Insights
 * Returns both userToken (anonymous) and authenticatedUserToken if available
 * @param authenticatedToken - Authenticated user token from event payload
 * @param hasConsent - Whether user has granted consent for tracking
 * @returns Object containing userToken and optional authenticatedUserToken
 */
export function getUserToken(
  authenticatedToken?: string,
  hasConsent = false
): UserTokens {
  return {
    userToken: getAnonymousUserToken(hasConsent),
    authenticatedUserToken: authenticatedToken || undefined,
  }
}
